module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/archive/archive/archive.component.css
// module id = ./src/app/views/archive/archive/archive.component.css
// module chunks = main